import script from "./TocNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./TocNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./TocNavigation.vue?vue&type=style&index=0&id=dac6f35e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac6f35e"]])

export default __exports__